export enum ClientPath {
  ABSA = 'absa',
  ALPHACARD = 'platinum',
  CENTURIONBE = 'centurion-be',
  BANCO_PICHINCHA = 'banco-pichincha',
  BANK_OF_EAST_ASIA = 'thebankofeastasia',
  BANK_OF_MELBOURNE = 'bankofmelbourne',
  BANKSA = 'banksa',
  BANKSAWP = 'banksawp',
  BARCLAYCARD = 'barclaycard',
  BARCLAYS = 'barclays',
  CARLAUREN = 'carlauren',
  CENTURION = 'centurion',
  CNB = 'cnb',
  COUTTS = 'coutts',
  CREDIT_ONE = 'creditone',
  CREDIT_SAISON_DIAMOND = 'creditsaisondiamond',
  CREDIT_SAISON_PREMIUM_v2 = 'creditsaisonpremium',
  CREDITSAISON = 'creditsaison',
  DBSAMEX = 'dbsamex',
  DILLARDS = 'dillards',
  DISCOVER = 'discover',
  DNB = 'dnb',
  DNBSAGA = 'dnb-saga',
  GINZASIXCARD = 'ginza-six-card',
  HSBC_JADE = 'hsbc-jade',
  HSBC_VISA = 'hsbc-visa',
  HSBCCONCIERGE = 'hsbc-concierge',
  ITAU = 'itau',
  MASTERCARD = 'mastercard',
  MASTERCARD_CITI = 'Mastercard_Citi',
  MASTERCARD_HNW = 'mastercard-hnw',
  MASTERCARD_RAK = 'mastercard-rak',
  MASTERCARD_RAK_BANK = 'mastercard-rakbank',
  MORGANSTANLEY = 'morganstanley',
  NATWEST = 'NatWest',
  NAVY_FEDERAL = 'navy-federal',
  NOMURA = 'nomura',
  OCBC = 'ocbc',
  RAISR = 'raisr',
  RBC = 'rbc',
  RBS = 'RBS',
  SCOTIA_EVASION = 'scotia-evasion',
  SCOTIA_PURSUITS = 'scotia-pursuits',
  SJPCONCIERGE = 'sjpconcierge',
  SNBAR = 'snbar',
  SNBEN = 'snben',
  SPW = 'spw',
  STGEORGE = 'stgeorge',
  SWISSCARD = 'swisscard',
  TEN = 'ten',
  TRANSAMERICA = 'transamerica',
  VISA_CEMEA = 'visa-cemea',
  VISA_LAC = 'visa-lac',
  VODAFONE = 'vodafone',
  WELLS_FARGO = 'wells-fargo',
  WESTPAC = 'westpac',
  SCOTIA_PLATINUM = 'scotia-platinum',
  SCOTIA_GOLD = 'scotia-gold',
  BAC = 'bac',
  RBC_ENTERPRISE = 'rbc-enterprise',
  STANDARD_CHARTERED = 'standard-chartered',
  QORBIS = 'qorbis',
  VISA_TRIAL = 'visa-trial',
  MASTERCARD_NEO = 'mastercard-neo',
  GTC = 'gtc',
  LUXURY_CARD = 'luxury-card',
  TEN_SELFREG_BINPROD = 'ten-selfreg-binprod',
  TEN_SELFREG_EXTERNAL = 'ten-selfreg-external',
  TEN_SELFREG_TMREF1 = 'ten-selfreg-tmref1',
  VISA_US = 'visa-us',
  VISA_US_HOLDINGPAGE = 'visa-us-holdingpage',
  SANTANDER = 'santander',
  EAB = 'eab',
  MANULIFE = 'manulife',
  NWB = 'nwb',
  RBSBLACK = 'rbs-black',
  SMCC = 'smcc',
  // for site creation script
}

export function castClientNameToClientPathEnum(clientName: string): ClientPath | undefined {
  const key = Object.keys(ClientPath).find((k) => ClientPath[k] === clientName);

  return <ClientPath>ClientPath[key] || undefined;
}
